import React, { useState, useEffect } from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { format, addMonths, subMonths } from 'date-fns';
import { makeStyles } from '@mui/styles';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setSelectedDay, setSelectedMonth } from '../../reducers/event_reducer';

// Define styles
const useStyles = makeStyles({
  root: {
    padding: '16px',
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
  },
  dayBox: {
    padding: '8px',
    textAlign: 'center',
    cursor: 'pointer',
    justifyContent: 'space-between',
  },
  selectedDay: {
    padding: '6px 10px',
    borderRadius: '25px',
    color: 'white',
    backgroundColor: '#4D67EB',
    fontSize: '25px',
    marginTop: '5px',
  },
  normalDay: {
    padding: '6px 10px',
    borderRadius: '15px',
    marginTop: '5px',
    color: 'black',
    fontSize: '16px',
    backgroundColor: 'transparent',
  },
});

const MonthCalendar: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  
  // Initialize selected month on component mount and when date changes
  useEffect(() => {
    const monthString = format(currentDate, "MM/yyyy");
    dispatch(setSelectedMonth(monthString));
    // Clear day selection when month changes
    dispatch(setSelectedDay(null));
  }, [currentDate, dispatch]);

  const handlePrevMonth = () => {
    const newDate = subMonths(currentDate, 1);
    setCurrentDate(newDate);
  };

  const handleNextMonth = () => {
    const newDate = addMonths(currentDate, 1);
    setCurrentDate(newDate);
  };

  // Removed day click functionality

  // Removed day rendering functionality

  const getTranslatedMonth = (date: Date) => {
    const month = format(date, 'MMMM'); // Get full month name with first letter capitalized
    return t(`months.${month}`, month);
  };

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <IconButton onClick={handlePrevMonth} style={{ marginRight: '20px' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#151212" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M13.26 15.53L9.73999 12L13.26 8.46997" stroke="#151212" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </IconButton>
        <Typography variant="h6">
          {`${getTranslatedMonth(currentDate)} ${format(currentDate, 'yyyy')}`}
        </Typography>
        <IconButton onClick={handleNextMonth} style={{ marginLeft: '20px' }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="#191919" strokeWidth="1.25" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10.74 15.53L14.26 12L10.74 8.46997" stroke="#191919" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </IconButton>
      </Box>
    </Box>
  );
};

export default MonthCalendar;